<router-outlet></router-outlet>

<!-- Modal global de upload de foto (usuário, cliente, bandeira) -->
<app-photo-upload-modal></app-photo-upload-modal>
